import PPLBanner from './PPLBanner'

export default PPLBanner
